(function () {
  var HANDLE_VARIANT = function () { return window.LUMEN_INS_VARIANT; };
  var KEY = 'lumenInsuranceOptOut';
  var busy = false;
  function optedOut() { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function setOptOut(v) { try { v ? localStorage.setItem(KEY, '1') : localStorage.removeItem(KEY); } catch (e) {} }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function refresh() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return fetch(base + '?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (t) {
      var html = new DOMParser().parseFromString(t, 'text/html');
      ['cart-drawer-items', '.cart-drawer__footer', '.lumen-upsell', '.lumen-ins'].forEach(function (sel) {
        var a = document.querySelector(sel), b = html.querySelector(sel);
        if (a && b) a.replaceWith(b);
      });
      var drawer = document.querySelector('cart-drawer .drawer__inner');
      if (drawer) {
        var empty = html.querySelector('cart-drawer .drawer__inner');
        if (empty && empty.classList.contains('is-empty')) drawer.classList.add('is-empty'); else drawer.classList.remove('is-empty');
      }
      return fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
        var el = document.getElementById('cart-icon-bubble');
        if (el && s['cart-icon-bubble']) {
          var d = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (d) el.innerHTML = d.innerHTML;
        }
      });
    });
  }
  window.lumenCartRefresh = refresh;
  function sync() {
    var vid = HANDLE_VARIANT();
    if (!vid || busy) return Promise.resolve();
    busy = true;
    return getCart().then(function (cart) {
      var line = cart.items.filter(function (i) { return String(i.variant_id) === String(vid); })[0];
      var others = cart.items.filter(function (i) { return String(i.variant_id) !== String(vid); });
      if (!others.length) {
        setOptOut(false);
        return line ? post('/cart/change.js', { id: line.key, quantity: 0 }).then(refresh) : null;
      }
      if (!line && !optedOut()) return post('/cart/add.js', { items: [{ id: Number(vid), quantity: 1 }] }).then(refresh);
      if (line && line.quantity !== 1) return post('/cart/change.js', { id: line.key, quantity: 1 }).then(refresh);
      if (document.querySelector('.lumen-ins')) return refresh();
    }).catch(function (e) { console.error(e); }).then(function () { busy = false; });
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-lumen-ins-toggle]')) return;
    var vid = HANDLE_VARIANT(); if (!vid) return;
    t.disabled = true; busy = true;
    var done = function () { busy = false; };
    if (t.checked) {
      setOptOut(false);
      post('/cart/add.js', { items: [{ id: Number(vid), quantity: 1 }] }).then(refresh).catch(console.error).then(done);
    } else {
      setOptOut(true);
      getCart().then(function (cart) {
        var line = cart.items.filter(function (i) { return String(i.variant_id) === String(vid); })[0];
        return line ? post('/cart/change.js', { id: line.key, quantity: 0 }) : null;
      }).then(refresh).catch(console.error).then(done);
    }
  });
  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(sync, 50); });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
